import React, { useState } from "react";
import {
  Box,
  Card,
  CardContent,
  CardMedia,
  Typography,
  Grid,
} from "@mui/material";
import { useNavigate } from "react-router-dom";

export default function ArticleCardList({ articles = [] }) {
  const BASE_URL = process.env.REACT_APP_API_URL;
  const navigate = useNavigate();
  const [hoverTimelineId, setHoverTimelineId] = useState(null);

  return (
    <Grid container spacing={3} justifyContent="center">
      {articles.map((article) => (
        <Grid item key={article.id}>
          <Card
            onClick={() => navigate(`/articles/${article.id}`)}
            sx={{
              display: "flex",
              flexDirection: "column",
              height: "100%",
              borderTop: "3px solid red",
              boxShadow: "none",
              borderRadius: 0,
              width: 305,
              position: "relative",
              cursor: "pointer",
              transition: "transform 0.2s, box-shadow 0.2s",
              "&:hover": {
                boxShadow: "0px 4px 20px rgba(0, 0, 0, 0.2)",
                transform: "scale(1.02)",
              },
            }}
          >
            <Box position="relative">
              <CardMedia
                component="img"
                image={
                  article.thumbnail
                    ? `${BASE_URL}${article.thumbnail}`
                    : "https://via.placeholder.com/312x312.png?text=No+Image"
                }
                alt={article.title}
                sx={{ width: 312, height: 312, objectFit: "cover" }}
              />
            </Box>

            <Box
              sx={{
                position: "absolute",
                top: 312,
                left: 0,
                width: "4px",
                height: "calc(100% - 312px - 16px)",
                backgroundColor: "red",
              }}
            />

            <CardContent sx={{ flexGrow: 1, p: 1.5 }}>
              <Typography
                variant="subtitle2"
                fontWeight="bold"
                sx={{
                  "&:hover": {
                    textDecoration: "underline",
                    textDecorationColor: "black",
                  },
                  mb: 2,
                  fontSize: 18,
                }}
              >
                {article.title}
              </Typography>

              <Typography variant="body2" sx={{ color: "#444", mb: 2 }}>
                {article.description?.substring(0, 100)}...
              </Typography>

              <Typography variant="caption" sx={{ color: "gray" }}>
                {new Date(article.created_at).toLocaleDateString("vi-VN")}
              </Typography>

              <Box mt={1}>
                <span
                  className="badge bg-light text-dark"
                  onMouseEnter={() => setHoverTimelineId(article.id)}
                  onMouseLeave={() => setHoverTimelineId(null)}
                  onClick={(e) => {
                    e.stopPropagation();
                    const basePath =
                      article.category_name === "chienki" ? "/chienky" : "/luocsu";
                    const timelineQuery =
                      article.timeline_name === "1975"
                        ? "1975"
                        : article.timeline_name;

                    navigate(`${basePath}?timeline=${timelineQuery}`);
                  }}
                  style={{
                    fontSize: "15px",
                    display: "inline-block",
                    transition:
                      "transform 0.2s ease, background-color 0.2s ease",
                    cursor: "pointer",
                    borderRadius: "4px",
                    ...(hoverTimelineId === article.id && {
                      transform: "scale(1.15)",
                      backgroundColor: "rgba(0,0,0,0.1)",
                    }),
                  }}
                >
                  {article.category_name === "luocsu"
                    ? "Lược Sử"
                    : article.category_name === "chienki"
                      ? "Chiến Ký"
                      : article.category_name}

                  {article.timeline_name && (
                    <>
                      {" - "}
                      {{
                        "1975": "Sau 1975",
                        KCCM: "Kháng Chiến Chống Mỹ",
                        KCCP: "Kháng Chiến Chống Pháp",
                      }[article.timeline_name] || article.timeline_name}
                    </>
                  )}
                </span>
              </Box>
            </CardContent>
          </Card>
        </Grid>
      ))}
    </Grid>
  );
}
